// A single attack's hit rider uses the cast's ledger claim. Rays have child IDs.
export const directSpellAttackResolutionId = (cast, definition) => definition.multiAttack
  ? `${cast.id}:beam:${cast.completed + 1}` : cast.id;
export const confirmedDirectSpellAttackCount = spellAttack => {
  if (!spellAttack.multiAttack) return 1;
  if (!Number.isInteger(spellAttack.attackCount) || spellAttack.attackCount < 1) throw new Error('The spell attack count was not confirmed.');
  return spellAttack.attackCount;
};
// Server recovery takes precedence over a stale local ray cursor after a lost response.
export const reconcileNativeMultiattackCast = (cast, nativeCast) => {
  if(cast.id!==nativeCast.resolutionId)throw new Error('Another spell cast is still pending.');
  return {...cast,...nativeCast.resume,pending:nativeCast.resume?.pending || null,multiattack:nativeCast.multiattack};
};
